import { render, staticRenderFns } from "./ProfileVerificationResume.vue?vue&type=template&id=58ea160a&scoped=true&"
import script from "./ProfileVerificationResume.vue?vue&type=script&lang=js&"
export * from "./ProfileVerificationResume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ea160a",
  null
  
)

export default component.exports